import { render, staticRenderFns } from "./data-view-management.vue?vue&type=template&id=bf24109e&scoped=true&"
import script from "./data-view-management.vue?vue&type=script&lang=js&"
export * from "./data-view-management.vue?vue&type=script&lang=js&"
import style0 from "./data-view-management.vue?vue&type=style&index=0&id=bf24109e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24109e",
  null
  
)

export default component.exports